import * as stylex from '@stylexjs/stylex';

const styles = stylex.create({
  tracer: {
    position: 'fixed',
    top: '-1px',
    left: '-1px',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    pointerEvents: 'none',
    // Unique static marker — located in emitted CSS assets to prove extraction.
    outlineColor: 'rgb(1, 2, 3)',
    backgroundColor: 'var(--theme-palette-primary-main)',
  },
});

export default function StylexTracer() {
  return (
    <div
      aria-hidden="true"
      data-testid="stylex-tracer"
      {...stylex.props(styles.tracer)}
    />
  );
}
